import { useEffect, useState } from 'react'

import { layoutService } from '@/app/services/layout.service'

const DEFAULT_APP_VERSION = '1.0'

export function SystemVersion() {
    const [version, setVersion] = useState(DEFAULT_APP_VERSION)

    useEffect(() => {
        let isMounted = true

        layoutService
            .getSystemVersion()
            .then(({ version }) => {
                if (isMounted && version) {
                    setVersion(version)
                }
            })
            .catch(() => {
                if (isMounted) {
                    setVersion(DEFAULT_APP_VERSION)
                }
            })

        return () => {
            isMounted = false
        }
    }, [])

    return <span>v{version}</span>
}
